import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { Subject } from 'rxjs';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { CompanyDocumentService } from '../../Model/CompanyDocument/Document/company-document.service';
import { SessionService } from '../../Util/Session/session.service';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyFrameComponent } from '../company-frame/company-frame.component';

@Component({
  selector: 'app-company-document',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, DataTablesModule, LoaderComponent, FormsModule],
  templateUrl: './company-document.component.html',
  styleUrl: './company-document.component.scss'
})
export class CompanyDocumentComponent {
  isDisabled: boolean = false;
  user = [] as any;
  TableDatas = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    protected common: CommonService,
    private tooltip: TooltipService,
    private download: DownloadSampleService,
    private toast: ToastService,
    private companydocument: CompanyDocumentService,
    private session: SessionService,
    private modalService: NgbModal,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_CompanyPolicy_Employee();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_CompanyPolicy_Employee() {
    this.isDisabled = true;
    this.companydocument.ESS_CompanyPolicy_Employee({ Empmasterid: this.user.UserId }).subscribe({
      next: (response) => {
        this.TableDatas = Object.values(response.Table);
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
  LinkInTab(element: any) {
    if (element.IsTrainingVideo) {
      var url = element.TrainingURL
      if (url) {
        window.open(url, '_blank');
      }
      else {
        this.toast.show({ message: "No URL found!", type: toastTypeEnum.warning });
      }
    }else{
      if (element.Allowtodownload) {
        var url = element.DocumentAttachmentLink;
        if (url) {
          window.open(url, '_blank');
        }
        else {
          this.toast.show({ message: "No URL found!", type: toastTypeEnum.warning });
        }
      }
      else {
        const modalRef = this.modalService.open(CompanyFrameComponent, { centered: true, backdrop: 'static', size: 'xl'});
        modalRef.componentInstance.InputData = {
          DocumentAttachmentLink: element.DocumentAttachmentLink,
        };
        modalRef.result.then((result) => {
          if (result) {
          }
        }).catch((reason) => {
          console.log('Modal dismissed:', reason);
        });
      }
    }
  }
}
